export default __webpack_public_path__ + "static/media/tif.710165d6.svg";